import { Section, SectionSubtitle, SectionTitle } from '@web_opxp/components';
import { ETagType, renderStringToReact, useTranslation } from '@web_opxp/features';
import * as React from 'react';
import BenefitItem from './BenefitItem';
import './BenefitsSection.scss';

const BenefitsSection: React.FC = () => {
  const { t } = useTranslation();
  const descriptionHtml = t('prereg:Welcome.BenefitsSection.SubtitleHtml');
  return (
    <Section className="benefits-section">
      <SectionTitle>{t('prereg:Welcome.BenefitsSection.Title')}</SectionTitle>
      <SectionSubtitle wrapperTag="div">{renderStringToReact(descriptionHtml, ETagType.div)}</SectionSubtitle>
      <div className="row benefits-list">
        <BenefitItem html={t('prereg:Welcome.BenefitsSection.Benefit1Html')} />
        <BenefitItem html={t('prereg:Welcome.BenefitsSection.Benefit2Html')} />
        <BenefitItem html={t('prereg:Welcome.BenefitsSection.Benefit3Html')} />
      </div>
      <div className="row benefits-list">
        <BenefitItem html={t('prereg:Welcome.BenefitsSection.Benefit4Html')} />
        <BenefitItem html={t('prereg:Welcome.BenefitsSection.Benefit5Html')} />
        <BenefitItem html={t('prereg:Welcome.BenefitsSection.Benefit6Html')} />
      </div>
    </Section>
  );
};

export default BenefitsSection;
